import { useState, useEffect } from "react";
import api from "@/lib/api";

// Loads the restaurant's unlocked features. Returns null while loading.
export function useFeatures(rid) {
  const [features, setFeatures] = useState(null);
  useEffect(() => {
    if (!rid) return;
    api.get(`/restaurants/${rid}/features`)
      .then((r) => setFeatures(r.data.features || {}))
      .catch(() => setFeatures({}));
  }, [rid]);
  return features;
}
